import { Component, Injector, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PermissionConstants } from "src/app/core/constants/permission-constants.constant";
import { FaqSearchResult } from "src/app/core/models/faq/faq-search-result";
import { LaasOption } from "src/app/core/models/laas-option";
import { DropdownOptionsService } from "src/app/core/services/dropdown-options.service";
import { NotificationSubScriptionService } from "src/app/core/services/notification-sub-scription.service";
import { isNullOrEmpty } from "src/app/core/utils/common-functions";
import { FaqService } from "src/app/features/faq/services/faq.service";
import { SessionBaseComponent } from "src/app/shared/components/session.base.component";

@Component({
  selector: 'laas-faq-edit',
  templateUrl: './faq-edit.component.html',
  styleUrls: ['./faq-edit.component.scss']
})
export class FaqEditComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewFaqMaintenance;

  editForm: FormGroup;
  facilityOptions: LaasOption[] = [];
  tenantOptions: any[];

  constructor(
    injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private fb: FormBuilder,
    private faqService: FaqService
  ) {
    super(injector);
    this.tenantOptions = [];

    this.editForm = this.fb.group({
      seqNo: null,
      question: null,
      answer: null,
      facility: [],
      isActivated: null,
      createUser: null,
      createDt: null,
      updateUser: null,
      updateDt: null,
      tenantList: []
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    // rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({
          label: x.optionDesc,
          value: x.optionCode
        }));
      }
    });

    this.notificationSubScriptionService.getTenantOptions().subscribe({
      next: (options: any[]) => {
        this.tenantOptions = options.map(x => ({
          label: x.tenantCode + " - " + x.tenantName,
          value: x.tenantCode
        }));
        this.tenantOptions.unshift({
          value: "ALL",
          label: "ALL - 全部"
        });
      }
    });

    const routeData = this.routeStateService.getCurrent()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.faqService.getFaqBySeqNo(routeData.seqNo).subscribe({
        next: result => {
          this.editForm.controls.seqNo.setValue(result.seqNo);
          this.editForm.controls.question.setValue(result.question);
          this.editForm.controls.answer.setValue(result.answer);
          this.editForm.controls.facility.setValue(isNullOrEmpty(result.facility) ? null : result.facility.split(','));
          this.editForm.controls.isActivated.setValue(result.isActivated);
          this.editForm.controls.createUser.setValue(result.createUser);
          this.editForm.controls.createDt.setValue(result.createDt);
          this.editForm.controls.updateUser.setValue(result.updateUser);
          this.editForm.controls.updateDt.setValue(result.updateDt);
          this.editForm.controls.tenantList.setValue(isNullOrEmpty(result.tenant) ? null : result.tenant.split(','));
        }
      });
    }
  }

  saveBtnClick(): void {
    this.editForm.controls.updateUser.setValue(this.userProfile.userName);
    if (this.editForm.get("tenantList")?.value.includes('ALL')) {
      this.editForm.controls.tenantList.setValue(['ALL']);
    }
    this.faqService.updateFaq(this.editForm.value).subscribe({
      next: (result: FaqSearchResult[]) => {
        this.routeStateService.navigateTo('/Setting/FaqMaintenance');
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }
}
